var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h6", { staticClass: "mb-1" }, [
        _vm._v(" " + _vm._s(_vm.$t("Regras Específicas de Destino")) + " "),
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("e-button", {
                attrs: {
                  variant: "primary",
                  size: "sm",
                  icon: "plus-circle",
                  text: _vm.$t("Adicionar regra de destino"),
                },
                on: { click: _vm.openAddDestinationRuleModal },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "destination-rule-modal",
            title: _vm.$t(
              _vm.editIndex !== null
                ? "Editar Regra de Destino"
                : "Nova Regra de Destino"
            ),
            size: "xl",
            scrollable: "",
            centered: "",
          },
          on: { hide: _vm.onModalHide },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end mt-2" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1",
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.hide("destination-rule-modal")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Cancelar")))]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.saveDestinationRuleFromModal },
                        },
                        [_vm._v(_vm._s(_vm.$t("Salvar")))]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-container",
            [
              _vm.modalError
                ? _c(
                    "b-alert",
                    {
                      staticClass: "mb-1 p-2",
                      attrs: { show: "", variant: "danger" },
                    },
                    [_vm._v(" " + _vm._s(_vm.modalError) + " ")]
                  )
                : _vm._e(),
              _c(
                "FormulateForm",
                {
                  ref: "modalTaxParameterDestinationFormRef",
                  attrs: { name: "modalTaxParameterDestinationForm" },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("FormulateInput", {
                            staticClass: "required",
                            attrs: {
                              id: "modal-tax-parameter-destination-state-id-ibge",
                              name: "modalTaxParameterDestinationStateIdIbge",
                              type: "vue-select",
                              options: _vm.getComboStatesIdValue,
                              label: _vm.$t("Estado (UF)"),
                              validation: "required",
                              placeholder: _vm.$t("Selecione"),
                            },
                            on: { input: _vm.onStateChange },
                            model: {
                              value: _vm.destinationRule.stateIdIbge,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "stateIdIbge",
                                  $$v
                                )
                              },
                              expression: "destinationRule.stateIdIbge",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("e-city-search", {
                            ref: "taxParameterCityIdIbgeRef",
                            attrs: {
                              id: "tax-parameter-destination-city-id-ibge",
                              name: "tax-parameter-destination-city-id-ibge",
                              "state-id-ibge": _vm.destinationRule.stateIdIbge,
                              disabled: !_vm.destinationRule.stateIdIbge,
                              label: _vm.$t("Município"),
                              required: !_vm.destinationRule.stateIdIbge,
                            },
                            model: {
                              value: _vm.destinationRule.cityIdIbge,
                              callback: function ($$v) {
                                _vm.$set(_vm.destinationRule, "cityIdIbge", $$v)
                              },
                              expression: "destinationRule.cityIdIbge",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("hr"),
                  _c("h6", { staticClass: "mb-1 mt-1" }, [
                    _vm._v(" " + _vm._s(_vm.$t("CBS/IBS")) + " "),
                  ]),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-st-cbs-ibs",
                              name: "tax-parameter-destination-st-cbs-ibs",
                              type: "vue-select",
                              options: _vm.comboCstCbsIbs,
                              label: _vm.$t("ST CBS/IBS"),
                              placeholder: _vm.$t("Selecione"),
                            },
                            model: {
                              value: _vm.destinationRule.stCbsIbsCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "stCbsIbsCode",
                                  $$v
                                )
                              },
                              expression: "destinationRule.stCbsIbsCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-fiscal-classification-cbs-ibs",
                              name: "tax-parameter-destination-fiscal-classification-cbs-ibs",
                              type: "vue-select",
                              disabled: !_vm.destinationRule.stCbsIbsCode,
                              options: _vm.comboFiscalClassificationCbsIbs,
                              label: _vm.$t("Class. CBS/IBS"),
                              placeholder: _vm.$t("Selecione"),
                            },
                            model: {
                              value:
                                _vm.destinationRule
                                  .fiscalClassificationCbsIbsCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "fiscalClassificationCbsIbsCode",
                                  $$v
                                )
                              },
                              expression:
                                "destinationRule.fiscalClassificationCbsIbsCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.destinationRatesVisible,
                              expression: "destinationRatesVisible",
                            },
                          ],
                          attrs: { md: "4" },
                        },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-cbs-percent",
                              name: "tax-parameter-destination-cbs-percent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 4,
                              label: _vm.$t("CBS %"),
                              validation: "min:0|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                            },
                            model: {
                              value: _vm.destinationRule.cbsPercent,
                              callback: function ($$v) {
                                _vm.$set(_vm.destinationRule, "cbsPercent", $$v)
                              },
                              expression: "destinationRule.cbsPercent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.destinationRatesVisible,
                              expression: "destinationRatesVisible",
                            },
                          ],
                          attrs: { md: "4" },
                        },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-cbs-reduction-percent",
                              name: "tax-parameter-destination-cbs-reduction-percent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 4,
                              label: _vm.$t("Redução CBS %"),
                              validation: "min:0|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                            },
                            model: {
                              value: _vm.destinationRule.cbsReductionPercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "cbsReductionPercent",
                                  $$v
                                )
                              },
                              expression: "destinationRule.cbsReductionPercent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.destinationRatesVisible,
                              expression: "destinationRatesVisible",
                            },
                          ],
                          attrs: { md: "4" },
                        },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-cbs-deferral-percent",
                              name: "tax-parameter-destination-cbs-deferral-percent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 4,
                              label: _vm.$t("Dif. CBS %"),
                              validation: "min:0|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                            },
                            model: {
                              value: _vm.destinationRule.cbsDeferralPercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "cbsDeferralPercent",
                                  $$v
                                )
                              },
                              expression: "destinationRule.cbsDeferralPercent",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("hr"),
                  _vm.destinationRatesVisible
                    ? _c("h6", { staticClass: "mb-1 mt-1" }, [
                        _vm._v(" " + _vm._s(_vm.$t("IBS Estadual")) + " "),
                      ])
                    : _vm._e(),
                  _c(
                    "b-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.destinationRatesVisible,
                          expression: "destinationRatesVisible",
                        },
                      ],
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-ibs-state-percent",
                              name: "tax-parameter-destination-ibs-state-percent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 4,
                              label: _vm.$t("IBS UF %"),
                              validation: "min:0|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                            },
                            model: {
                              value: _vm.destinationRule.ibsStatePercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "ibsStatePercent",
                                  $$v
                                )
                              },
                              expression: "destinationRule.ibsStatePercent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-ibs-state-reduction-percent",
                              name: "tax-parameter-destination-ibs-state-reduction-percent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 4,
                              label: _vm.$t("Red. IBS UF %"),
                              validation: "min:0|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                            },
                            model: {
                              value:
                                _vm.destinationRule.ibsStateReductionPercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "ibsStateReductionPercent",
                                  $$v
                                )
                              },
                              expression:
                                "destinationRule.ibsStateReductionPercent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "tax-parameter-destination-ibs-state-deferral-percent",
                              name: "tax-parameter-destination-ibs-state-deferral-percent",
                              type: "text-percetage",
                              currency: "%",
                              precision: 4,
                              label: _vm.$t("Dif. IBS UF %"),
                              validation: "min:0|max:1",
                              "validation-messages": Object.assign(
                                {},
                                _vm.mxGetTextPercentageValidationMessages
                              ),
                            },
                            model: {
                              value:
                                _vm.destinationRule.ibsStateDeferralPercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.destinationRule,
                                  "ibsStateDeferralPercent",
                                  $$v
                                )
                              },
                              expression:
                                "destinationRule.ibsStateDeferralPercent",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("hr"),
                  _vm.destinationRatesVisible
                    ? _c("h6", { staticClass: "mb-1 mt-1" }, [
                        _vm._v(" " + _vm._s(_vm.$t("IBS Municipal")) + " "),
                      ])
                    : _vm._e(),
                  _vm.destinationRatesVisible
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "tax-parameter-destination-ibs-municipal-percent",
                                  name: "tax-parameter-destination-ibs-municipal-percent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 4,
                                  label: _vm.$t("IBS Mun. %"),
                                  validation: "min:0|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.destinationRule.ibsMunicipalPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.destinationRule,
                                      "ibsMunicipalPercent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "destinationRule.ibsMunicipalPercent",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "tax-parameter-destination-ibs-municipal-reduction-percent",
                                  name: "tax-parameter-destination-ibs-municipal-reduction-percent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 4,
                                  label: _vm.$t("Red. IBS Mun. %"),
                                  validation: "min:0|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.destinationRule
                                      .ibsMunicipalReductionPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.destinationRule,
                                      "ibsMunicipalReductionPercent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "destinationRule.ibsMunicipalReductionPercent",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  id: "tax-parameter-destination-ibs-municipal-deferral-percent",
                                  name: "tax-parameter-destination-ibs-municipal-deferral-percent",
                                  type: "text-percetage",
                                  currency: "%",
                                  precision: 4,
                                  label: _vm.$t("Dif. IBS Mun. %"),
                                  validation: "min:0|max:1",
                                  "validation-messages": Object.assign(
                                    {},
                                    _vm.mxGetTextPercentageValidationMessages
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.destinationRule
                                      .ibsMunicipalDeferralPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.destinationRule,
                                      "ibsMunicipalDeferralPercent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "destinationRule.ibsMunicipalDeferralPercent",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  false
                    ? [
                        _c("hr"),
                        _c("h6", { staticClass: "mb-1 mt-1" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("Imposto Seletivo (Regra de Destino)")
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-parameter-destination-st-selective-tax",
                                    name: "tax-parameter-destination-st-selective-tax",
                                    type: "vue-select",
                                    options: _vm.comboCstCbsIbs,
                                    label: _vm.$t("ST Imposto Seletivo"),
                                    placeholder: _vm.$t("Selecione"),
                                  },
                                  model: {
                                    value:
                                      _vm.destinationRule.stSelectiveTaxCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.destinationRule,
                                        "stSelectiveTaxCode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "destinationRule.stSelectiveTaxCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "5" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-parameter-destination-fiscal-classification-selective-tax",
                                    name: "tax-parameter-destination-fiscal-classification-selective-tax",
                                    disabled:
                                      !_vm.destinationRule.stSelectiveTaxCode,
                                    type: "vue-select",
                                    options: _vm.comboSelectiveClassTribs,
                                    label: _vm.$t(
                                      "Classificação Imposto Seletivo"
                                    ),
                                    placeholder: _vm.$t("Selecione"),
                                  },
                                  model: {
                                    value:
                                      _vm.destinationRule
                                        .fiscalClassificationSelectiveTaxCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.destinationRule,
                                        "fiscalClassificationSelectiveTaxCode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "destinationRule.fiscalClassificationSelectiveTaxCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-parameter-destination-selective-tax-type",
                                    name: "tax-parameter-destination-selective-tax-type",
                                    disabled: true,
                                    type: "vue-select",
                                    options: _vm.comboSelectiveTaxTypes,
                                    label: _vm.$t("Tipo Imposto Seletivo"),
                                    placeholder: _vm.$t("Selecione"),
                                  },
                                  model: {
                                    value: _vm.destinationRule.selectiveTaxType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.destinationRule,
                                        "selectiveTaxType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "destinationRule.selectiveTaxType",
                                  },
                                }),
                              ],
                              1
                            ),
                            false &&
                            _vm.destinationRule.selectiveTaxType ===
                              "PERCENTAGE_BY_BASE_VALUE"
                              ? _c(
                                  "b-col",
                                  { attrs: { md: "3" } },
                                  [
                                    _c("FormulateInput", {
                                      attrs: {
                                        id: "tax-parameter-destination-selective-tax-percent",
                                        name: "tax-parameter-destination-selective-tax-percent",
                                        type: "text-percetage",
                                        currency: "%",
                                        precision: 4,
                                        label: _vm.$t("% Imposto Seletivo"),
                                        validation: "required|min:0|max:1",
                                        "validation-messages": Object.assign(
                                          {},
                                          _vm.mxGetTextPercentageValidationMessages
                                        ),
                                        disabled: true,
                                      },
                                      model: {
                                        value:
                                          _vm.destinationRule
                                            .selectiveTaxPercent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.destinationRule,
                                            "selectiveTaxPercent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "destinationRule.selectiveTaxPercent",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            false &&
                            _vm.destinationRule.selectiveTaxType ===
                              "PERCENTAGE_BY_UNIT"
                              ? _c(
                                  "b-col",
                                  { attrs: { md: "3" } },
                                  [
                                    _c("FormulateInput", {
                                      attrs: {
                                        id: "tax-parameter-destination-selective-tax-value-per-unit",
                                        name: "tax-parameter-destination-selective-tax-value-per-unit",
                                        type: "text-percetage",
                                        currency: "R$",
                                        precision: 4,
                                        label: _vm.$t(
                                          "Valor/Un. Imposto Seletivo"
                                        ),
                                        validation: "required",
                                        disabled: true,
                                      },
                                      model: {
                                        value:
                                          _vm.destinationRule
                                            .selectiveTaxValuePerUnit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.destinationRule,
                                            "selectiveTaxValuePerUnit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "destinationRule.selectiveTaxValuePerUnit",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.fiscalTaxParameter.specificDestinationRules.length
        ? _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    staticClass: "bordered",
                    attrs: {
                      "show-empty": "",
                      responsive: "",
                      striped: "",
                      items: _vm.destinationTableItems,
                      fields: _vm.destinationFields,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(actions)",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("e-grid-actions", {
                                attrs: {
                                  "show-update": true,
                                  "show-delete": true,
                                },
                                on: {
                                  update: function () {
                                    return _vm.openEditDestinationRuleModal(
                                      item
                                    )
                                  },
                                  delete: function () {
                                    return _vm.removeDestinationRuleHandler(
                                      item
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1056333527
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }